/**
 * Shared numeric tokens for sheet form headers (logo tile size, etc.).
 * @see ../atomicRules.ts
 */
import { appTheme } from '../../appTheme';

/** Logo tile in sheet form header. Used by: credential form sheet content. */
export const sheetFormHeaderLogoSize = appTheme.spacing.xl * 2 + appTheme.spacing.xs;
